import { useState } from 'react';
import { contactApi } from '../api/contact';
import '../styles/PublicPages.css';
import './Contact.css';

function Contact() {
	const [formData, setFormData] = useState({
		name: '',
		email: '',
		message: '',
	});
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [submitStatus, setSubmitStatus] = useState({
		type: null,
		message: '',
	});

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData((prev) => ({
			...prev,
			[name]: value,
		}));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setIsSubmitting(true);
		setSubmitStatus({ type: null, message: '' });

		try {
			const contactData = {
				...formData,
				subject: 'New Contact Form Submission from Website',
				template: 'contact',
				isInquiry: true,
			};

			console.log('Sending contact data:', contactData);
			await contactApi.sendContactEmail(contactData);

			setSubmitStatus({
				type: 'success',
				message:
					"Message sent successfully! We'll get back to you soon.",
			});

			// Clear form
			setFormData({
				name: '',
				email: '',
				message: '',
			});
		} catch (error) {
			console.error('Contact form error:', error);
			setSubmitStatus({
				type: 'error',
				message:
					error.response?.data?.message ||
					'Failed to send message. Please try again later.',
			});
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<div className='contact-container'>
			<section className='contact-hero'>
				<h1>Contact Us</h1>
				<p>We'd love to hear from you</p>
			</section>

			<section className='contact-content'>
				<div className='contact-info'>
					<h2>Get in Touch</h2>
					<p>
						Have questions about Assemblie or want to get started?
						We're here to help!
					</p>

					<div className='contact-details'>
						<div className='contact-item'>
							<h3>Email</h3>
							<p>christian.lovern@assemblie.app</p>
						</div>

						<div className='contact-item'>
							<h3>Phone</h3>
							<p>(828) 493-0490</p>
						</div>
					</div>
				</div>

				<div className='contact-form'>
					<h2>Send us a Message</h2>

					{submitStatus.type && (
						<div className={`submit-status ${submitStatus.type}`}>
							{submitStatus.message}
						</div>
					)}

					<form onSubmit={handleSubmit}>
						<div className='form-group'>
							<input
								type='text'
								name='name'
								placeholder='Your Name'
								value={formData.name}
								onChange={handleChange}
								required
								disabled={isSubmitting}
							/>
						</div>
						<div className='form-group'>
							<input
								type='email'
								name='email'
								placeholder='Your Email'
								value={formData.email}
								onChange={handleChange}
								required
								disabled={isSubmitting}
							/>
						</div>
						<div className='form-group'>
							<textarea
								name='message'
								placeholder='Your Message'
								value={formData.message}
								onChange={handleChange}
								required
								disabled={isSubmitting}></textarea>
						</div>
						<button
							type='submit'
							disabled={isSubmitting}>
							{isSubmitting ? 'Sending...' : 'Send Message'}
						</button>
					</form>
				</div>
			</section>
		</div>
	);
}

export default Contact;
